/** Top-level category labels used across category filters. */
export const CATEGORY_LABELS = {
  A: "Ideen",
  B: "Essen",
  C: "Aktivitäten",
  D: "Für mich",
};
